import * as React from 'react';

import Button from '@pinecast/common/Button';
import {defineMessages, FormattedMessage, useIntl} from '@pinecast/i18n';
import ListenNow from '@pinecast/sl-spa/ListenNow';
import IconButton from '@pinecast/common/IconButton';
import ModalLayer from '@pinecast/common/ModalLayer';
import TextInput from '@pinecast/common/TextInput';
import {useCSS} from '@pinecast/styles';
import {useIsMobile} from '@pinecast/common/hooks/useIsMobile';

import {MOBILE} from './mobile';
import {Episode, Podcast} from './models';
import {Cross, RSSSmall} from '@pinecast/common/icons';

const messages = defineMessages({
  close: {
    id: 'pl-spa.Artwork.close',
    description: 'Button to close the subscribe links',
    defaultMessage: 'Close',
  },
  subscribe: {
    id: 'pl-spa.Artwork.subscribe',
    description: 'Link to subscribe to the podcast',
    defaultMessage: 'Subscribe',
  },
});

type Props = {
  episode: Episode;
  podcast: Podcast;
  src: string;
};

const Artwork = ({episode, podcast, src}: Props) => {
  const css = useCSS();
  const intl = useIntl();

  const isMobile = useIsMobile();

  const [subscribeOpen, setSubscribeOpen] = React.useState(false);

  return (
    <>
      <div
        className={css({
          borderRadius: '6px',
          boxShadow: '0 2px 0 rgba(0, 0, 0, 0.1)',
          width: '150px',
          height: '150px',
          gridArea: '1 / 1 / 3 / 1',
          position: 'relative',
          transition: 'height 0.2s, width 0.2s',
          [MOBILE]: {
            height: '96px',
            width: '96px',
          },

          ':hover .ArtworkMenu': {
            opacity: 1,
          },
          ':focus .ArtworkMenu': {
            opacity: 1,
          },
          ':focus-within .ArtworkMenu': {
            opacity: 1,
          },
        })}
      >
        <img
          className={css({
            borderRadius: '6px',
            transition: 'height 0.2s, width 0.2s',
            width: '150px',
            height: '150px',
            [MOBILE]: {
              height: '96px',
              width: '96px',
            },
          })}
          src={src}
          alt=""
        />
        {/* TODO: make this be its own variable */}
        {!podcast.cobranding && (
          <div
            className={css(
              {
                background: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 0,
                padding: '8px',
                position: 'absolute',
                transition: 'opacity 0.2s',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              },
              'ArtworkMenu',
            )}
          >
            <Button
              onClick={() => setSubscribeOpen(true)}
              size={isMobile ? 'small' : 'normal'}
            >
              <FormattedMessage {...messages.subscribe} />
            </Button>
          </div>
        )}
        {!podcast.cobranding && isMobile && (
          <div
            className={css({position: 'absolute', bottom: '8px', left: '8px'})}
          >
            <RSSSmall
              style={{color: '#fff', filter: 'drop-shadow(0 0 3px #000)'}}
              size={20}
            />
          </div>
        )}
      </div>
      <ModalLayer
        canEscape
        open={subscribeOpen}
        onClose={() => setSubscribeOpen(false)}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'stretch',
          })}
        >
          <IconButton
            title={intl.formatMessage(messages.close)}
            Component={Cross}
            onClick={() => setSubscribeOpen(false)}
            style={{alignSelf: 'flex-end', color: '#fff'}}
          />
          <ListenNow
            podcast={podcast}
            showHeader={false}
            prefix={`https://pnc.st/s/${podcast.slug}/${episode.site_id}/_`}
          />
          <TextInput
            readOnly
            value={`https://pinecast.com/feed/${podcast.slug}`}
          />
        </div>
      </ModalLayer>
    </>
  );
};

export default Artwork;
